import React, { Component } from "react";
import { Home, ChevronRight } from "react-feather";
import { Link } from "react-router-dom";

export class Breadcrumb extends Component {
  render() {
    const { title, parent } = this.props;

    // Truncate for the trail label (right side)
    const trailLabel =
      title && title.length > 36 ? title.slice(0, 36).trim() + "…" : title;

    return (
      <div
        className="container-fluid"
        style={{ paddingLeft: 15, paddingRight: 15 }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 10,
            padding: "14px 20px",
            marginBottom: 20,
            marginTop: 4,
            boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
            borderLeft: "4px solid rgb(251, 148, 4)",
          }}
        >
          <div
            className="row"
            style={{ alignItems: "center", margin: 0 }}
          >
            {/* Left: label + title */}
            <div className="col-lg-7 col-12" style={{ padding: 0 }}>
              {parent && (
                <div
                  style={{
                    fontSize: 10,
                    fontWeight: 700,
                    color: "#a0abc0",
                    textTransform: "uppercase",
                    letterSpacing: 1.2,
                    marginBottom: 4,
                  }}
                >
                  {parent}
                </div>
              )}
              <h3
                style={{
                  margin: 0,
                  fontSize: 17,
                  fontWeight: 700,
                  color: "#1a1f36",
                  textTransform: "none",
                  lineHeight: 1.35,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  fontFamily: "inherit",
                }}
              >
                {title || "—"}
              </h3>
            </div>

            {/* Right: breadcrumb trail */}
            <div
              className="col-lg-5 col-12"
              style={{
                padding: 0,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                marginTop: window.innerWidth < 992 ? 8 : 0,
              }}
            >
              <nav
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 4,
                  fontSize: 12,
                  color: "#6b7280",
                  flexWrap: "nowrap",
                  overflow: "hidden",
                }}
              >
                <Link
                  to="/dashboard"
                  style={{
                    color: "#6b7280",
                    display: "flex",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Home size={13} />
                </Link>

                {parent && (
                  <>
                    <ChevronRight size={12} style={{ color: "#d1d5db", flexShrink: 0 }} />
                    <span
                      style={{
                        color: "#6b7280",
                        whiteSpace: "nowrap",
                        flexShrink: 0,
                      }}
                    >
                      {parent}
                    </span>
                  </>
                )}

                {title && (
                  <>
                    <ChevronRight size={12} style={{ color: "#d1d5db", flexShrink: 0 }} />
                    <span
                      style={{
                        color: "rgb(251, 148, 4)",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: 220,
                        display: "inline-block",
                      }}
                      title={title}
                    >
                      {trailLabel}
                    </span>
                  </>
                )}
              </nav>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Breadcrumb;
